import clsx from 'clsx';
import { Tooltip } from 'flowbite-react';
import type React from 'react';

export const AppHeaderButton: React.FC<{
    children: React.ReactNode;
    style?: 'default'|'primary'|'primary-toggle'|'feature-accent';
    size?: 'sm'|'md'|'lg';
    responsive?: boolean;
    iconOnly?: boolean;
    disabled?: boolean;
    className?: string;
    tooltip?: string;
    onClick?: () => void;
}> = ({
    style = 'default',
    size = 'md',
    responsive = true,
    iconOnly,
    disabled,
    children,
    className = 'flex',
    tooltip,
    onClick
}) => {
    const button = (
        <button
            className={clsx(
                'flex-row shrink-0 items-center justify-center gap-1 text-sm font-medium transition-colors duration-200 rounded-full',
                size === 'sm' && iconOnly && 'w-6 h-6',
                size === 'sm' && !iconOnly && 'h-6 lg:w-auto lg:pl-2 lg:pr-2.5',
                size === 'sm' && !iconOnly && responsive && 'w-6',
                size === 'sm' && !iconOnly && !responsive && 'w-auto pl-2 pr-2.5',

                size === 'md' && iconOnly && 'w-8 h-8',
                size === 'md' && !iconOnly && 'w-8 h-8 lg:w-auto lg:pl-3 lg:pr-3.5',
                size === 'md' && !iconOnly && responsive && 'w-8',
                size === 'md' && !iconOnly && !responsive && 'w-auto pl-3 pr-3.5',

                size === 'lg' && iconOnly && 'w-10 h-10',
                size === 'lg' && !iconOnly && 'w-10 h-10 lg:w-auto lg:pl-4 lg:pr-[1.125rem]',
                size === 'lg' && !iconOnly && responsive && 'w-10',
                size === 'lg' && !iconOnly && !responsive && 'w-auto pl-4 pr-[1.125rem]',

                style === 'feature-accent' && 'p-[1px] relative overflow-hidden text-white before:absolute before:-left-1/2 before:-top-1/2 before:bg-gradient-to-r before:from-primary-500 before:to-violet-800 before:w-[200%] before:aspect-square before:animate-spin before:[animation-duration:3s] before:z-0 outline outline-2 outline-transparent hover:outline-white',

                !disabled && 'cursor-pointer',
                disabled && 'cursor-auto',
                !disabled && style === 'default' && 'border border-gray-300 hover:bg-white hover:border-white',
                !disabled && style === 'primary' && 'bg-primary-500 hover:bg-primary-550 text-white',
                !disabled && style === 'primary-toggle' && 'border',
                disabled && style === 'default' && 'text-gray-500',
                disabled && style === 'primary' && 'text-gray-500 bg-gray-300',
                className
            )}
            onClick={onClick}
            disabled={disabled}
        >{children}</button>
    );

    if (tooltip) {
        return <Tooltip content={tooltip}>{button}</Tooltip>;
    }

    return button;
};
